import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import LoadMoreCard from "@/components/Card/LoadMoreCard";
import ContentHeader from "@/components/ContentHeader";
import Loading from "@/components/Loading";
import SliderCore from "@/components/SliderCore";
import Card from "@/components/Card/index";
import { useDeviceInfoQuery, useCopyrights, useIntersectionObserver } from "@/hooks";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import styles from "@/styles/Slider.module.scss";
import classnames from "classnames";
import { cloneElement, createElement, useCallback, useEffect, useRef, useState, useMemo } from "react";

// 複数行にする場合はslidesPerColumnを指定する
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultSliderOptions = {
  slidesPerView: 2,
  slidesPerGroup: 2,
  breakpoints: {
    500: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    800: {
      slidesPerView: 4,
      slidesPerGroup: 4
    },
    1100: {
      slidesPerView: 5,
      slidesPerGroup: 5
    },
    1400: {
      slidesPerView: 6,
      slidesPerGroup: 6
    }
  },
  navigation: true,
  // pagination: { clickable: true },
  // lazy: true,
  freeMode: false
};
const largeCardBreakpoints = {
  breakpoints: {
    500: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    800: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    1100: {
      slidesPerView: 4,
      slidesPerGroup: 4
    }
  }
};
export default function Slider(_ref) {
  var _items$data$, _items$data, _items$data2;
  let {
    header,
    itemComponent = Card,
    loading,
    error,
    items,
    largeCard = false,
    noContent,
    className,
    options = {}
  } = _ref;
  if (error) {
    // TODO: error
    console.log(error);
    return null;
  }
  const rank = items === null || items === void 0 || (_items$data$ = items.data[0]) === null || _items$data$ === void 0 ? void 0 : _items$data$.rank;
  const sliderRef = useRef();
  const intersect = useIntersectionObserver(sliderRef, {
    root: null,
    rootMargin: "100px",
    threshold: 0.0
  });
  const {
    setCopyrights
  } = useCopyrights();
  const {
    data
  } = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  });
  const deviceInfo = data === null || data === void 0 ? void 0 : data.deviceInfo;
  const sliderOptions = useMemo(() => {
    if (deviceInfo && deviceInfo !== null && deviceInfo !== void 0 && deviceInfo.isMobile) {
      defaultSliderOptions.freeMode = true;
    }
    if (largeCard) {
      return Object.assign({}, defaultSliderOptions, largeCardBreakpoints, options);
    } else {
      return Object.assign({}, defaultSliderOptions, options);
    }
  }, [largeCard, deviceInfo, options]);
  const {
    0: focusIndex,
    1: setFocusIndex
  } = useState(null);
  const {
    0: slidesPerView,
    1: setSlidesPreView
  } = useState();
  const {
    0: activeIndex,
    1: setActiveIndex
  } = useState();
  const {
    0: swiperControl,
    1: setSwiperControl
  } = useState();
  const onSwiper = useCallback(control => {
    setSwiperControl(control);
  }, []);
  const handleMouseEnter = useCallback(e => {
    if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed) && !largeCard) {
      const {
        slides
      } = swiperControl;
      const current = e.currentTarget.parentElement;
      const currentIndex = slides.indexOf(current);
      setFocusIndex(currentIndex);
    }
  }, [swiperControl, largeCard]);
  const handleMouseLeave = useCallback(() => {
    setFocusIndex(null);
  }, [swiperControl]);
  useEffect(() => {
    const breakPointHandler = () => {
      if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed)) {
        const slidesPerView = swiperControl.params.slidesPerView;
        setSlidesPreView(slidesPerView);
      }
    };
    const activeIndexHandler = () => {
      if (swiperControl && !(swiperControl !== null && swiperControl !== void 0 && swiperControl.destroyed)) {
        const activeIndex = swiperControl.activeIndex;
        setActiveIndex(activeIndex);
      }
    };
    if (swiperControl) {
      swiperControl.on("breakpoint", breakPointHandler);
      breakPointHandler();
      swiperControl.on("activeIndexChange", activeIndexHandler);
      activeIndexHandler();
    }
    return () => {
      if (swiperControl) {
        swiperControl.off("breakpoint", breakPointHandler);
        swiperControl.off("activeIndexChange", activeIndexHandler);
      }
    };
  }, [swiperControl]);
  useEffect(() => {
    if (items) {
      const copyrights = items.data.map(item => item === null || item === void 0 ? void 0 : item.copyright);
      setCopyrights(copyrights);
    }
  }, [items]);
  const children = useMemo(() => {
    if (!loading && items) {
      const children = items.data.map((item, i) => /*#__PURE__*/_jsx("div", {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: /*#__PURE__*/createElement(itemComponent, {
          item,
          index: i,
          focusIndex,
          slidesPerView,
          activeIndex,
          slider: true,
          intersect
        })
      }, `item-${i}`));
      if (items.pageInfo.hasNextPage && header !== null && header !== void 0 && header.link) {
        children.push( /*#__PURE__*/_jsx("div", {
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          children: /*#__PURE__*/_jsx(LoadMoreCard, {
            index: SLIDER_MAX_NUM,
            focusIndex,
            slidesPerView,
            activeIndex,
            link: header === null || header === void 0 ? void 0 : header.link
          })
        }, `item-${SLIDER_MAX_NUM}`));
      }
      return children;
    } else {
      return null;
    }
  }, [loading, items, focusIndex, activeIndex, slidesPerView, intersect]);
  let noContentEle;
  if (!loading && (items === null || items === void 0 || (_items$data = items.data) === null || _items$data === void 0 ? void 0 : _items$data.length) === 0) {
    if (noContent) {
      noContentEle = /*#__PURE__*/cloneElement(noContent);
      // return <div className={styles.slider}>{cloneElement(noContent)}</div>;
    } else {
      return null;
    }
  }
  if (!deviceInfo) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.slider, className, {
      [styles.feature]: focusIndex != null,
      [styles.largeCard]: largeCard,
      [styles.mobile]: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMobile,
      [styles.rankCard]: rank
    }),
    ref: sliderRef,
    children: [header && /*#__PURE__*/_jsx(ContentHeader, _objectSpread({}, header)), loading && /*#__PURE__*/_jsx(Loading, {}), !loading && (items === null || items === void 0 || (_items$data2 = items.data) === null || _items$data2 === void 0 ? void 0 : _items$data2.length) === 0 && /*#__PURE__*/_jsx(_Fragment, {
      children: noContentEle
    }), !loading && items && /*#__PURE__*/_jsx(SliderCore, {
      sliderOptions: sliderOptions,
      onSwiper: onSwiper,
      children: children
    })]
  });
}